/** DOM-free iOS detection, shared by the page and the service worker (see ios-pwa.ts). */

export interface EnvLike {
  userAgent?: string
  platform?: string
  maxTouchPoints?: number
  /** iOS-only: true when launched from the Home Screen. */
  standalone?: boolean
  displayModeStandalone?: boolean
  hasPushManager?: boolean
  hasNotification?: boolean
  permission?: 'default' | 'granted' | 'denied'
}

/** iPhone, iPod and iPad (iPadOS 13+ reports itself as a Mac with touch points). */
export function isIOS(e: EnvLike): boolean {
  const ua = e.userAgent ?? ''
  if (/iPhone|iPad|iPod/.test(ua)) return true
  return /Mac/.test(e.platform ?? '') && (e.maxTouchPoints ?? 0) > 1
}

export function isInstalled(e: EnvLike): boolean {
  return !!e.standalone || !!e.displayModeStandalone
}
